import { render } from "./DeviceDetailsStep.vue?vue&type=template&id=187f99ae"
import script from "./DeviceDetailsStep.vue?vue&type=script&lang=js"
export * from "./DeviceDetailsStep.vue?vue&type=script&lang=js"

import "./DeviceDetailsStep.vue?vue&type=style&index=0&id=187f99ae&lang=css"

import exportComponent from "C:\\Users\\ser-mgk\\Documents\\Projekty\\CCS\\__DOPiK\\nowy-formularz-zgloszeniowy\\claim-form-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__